import { render, staticRenderFns } from "./RodapePrincipal.vue?vue&type=template&id=178b7a60&scoped=true"
import script from "./RodapePrincipal.vue?vue&type=script&lang=js"
export * from "./RodapePrincipal.vue?vue&type=script&lang=js"
import style0 from "./RodapePrincipal.vue?vue&type=style&index=0&id=178b7a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178b7a60",
  null
  
)

export default component.exports